'use strict';

export { default as ReactDataWrapper } from './reactDataWrapper.component';